import { useCallback, useEffect, useState } from "react";
import { fetchStudioSummary } from "../../api/client";
import { resolveBranding } from "../../presentationBranding";
import { DEFAULT_WORDMARK } from "../../portalContent";
import { readFlag, writeFlag } from "../../hooks/usePortal";
import DoorEntrance from "./DoorEntrance";
import Showcase from "./Showcase";

const OPENED_FLAG = "hacams.portal.opened";
const DEFAULT_NAME = "Pilates d'Luxe";

// Anonymous entry: the door, then the public "why join" showcase. Nothing here reads live studio state;
// only deployment branding is requested, and bundled defaults apply if it is unavailable.
export default function PublicPortal() {
  const deepLinked = typeof window !== "undefined" && window.location.hash === "#join";
  const [opened, setOpened] = useState(() => deepLinked || readFlag(OPENED_FLAG));
  const [branding, setBranding] = useState(() => resolveBranding());

  useEffect(() => {
    let active = true;
    fetchStudioSummary().then((summary) => { if (active && summary?.branding) setBranding(resolveBranding(summary.branding)); });
    return () => { active = false; };
  }, []);

  useEffect(() => {
    document.documentElement.classList.add("pt-root");
    return () => document.documentElement.classList.remove("pt-root");
  }, []);

  const handleOpened = useCallback(() => { writeFlag(OPENED_FLAG, true); setOpened(true); window.scrollTo(0, 0); }, []);

  const name = branding.deployment.name || DEFAULT_NAME;
  const wordmark = branding.deployment.logo || DEFAULT_WORDMARK;
  const attribution = branding.attribution.text ? branding.attribution.text.replace(/\s*HACaMS\s*$/i, "").trim() : "";

  return (
    <main className="pt-page">
      {opened
        ? <div className="pt-arrive"><Showcase wordmark={wordmark} name={name} attribution={attribution} /></div>
        : <DoorEntrance wordmark={wordmark} name={name} descriptor={branding.deployment.descriptor} onOpened={handleOpened} />}
    </main>
  );
}
